import React, {useEffect, useState} from 'react';
import axios from 'axios';
import "./ReturnCaseManagerButton.css";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import CaseUserStatus from "../../enums/CaseUserStatus";

const ReturnCaseManagerButton = ({ caseManagers, caseViewerManagers, onManagerAdded, userId}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [comment, setComment] = useState('');
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', type: '' });

    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const toggleConfirmation = () => setIsConfirmationOpen(!isConfirmationOpen);

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const deleteUnapprovedCaseViewerManagers = async () => {
        const unapprovedManagers = caseViewerManagers.filter(manager => manager.needApproval && !manager.approved);
        for (const manager of unapprovedManagers) {
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseUser`, {
                    id: manager.id
                });
            } catch (error) {
            }
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        toggleConfirmation();
    };

    const addCaseUserIsReturned = async (lastManagerId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseUserIsReturned`, {
                id: lastManagerId,
                returnComment: ""

            });
        } catch (error) {
        }
    };


    const confirmAndSubmit = async () => {
        await deleteUnapprovedCaseViewerManagers();

        const manager = caseManagers.find(manager => manager.toUserId === userId);

        if(!manager) return;

        const lastManagerStatus = manager.status;
        const caseId = new URLSearchParams(window.location.search).get('id');
        const toUserId = manager ? manager.fromUserId : caseManagers[0].fromUserId;
        const body = {
            caseId: parseInt(caseId),
            toUserId: toUserId,
            status: lastManagerStatus,
            returnComment: comment
        };

        try {

            const caseNotificationForExpert = {
                nextStepUserId: toUserId,
                caseId: parseInt(caseId, 10),
                documentId: null,
                action: CaseNotificationEnum.sentBack.id,
                caseStatus: 8,
                viewed: false,
                declinationReason: comment,
                caseUserType: CaseUserStatus.CaseUser
            };
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotificationForExpert);
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseUser`, body);
            await addCaseUserIsReturned(manager.id, comment);

            onManagerAdded();

            setAlertInfo({ show: true, message: 'ოპერაცია წარმატებით დასრულდა!', type: 'success' });
        } catch (error) {
            setAlertInfo({ show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error' });
        } finally {
            toggleModal();
            toggleConfirmation();
        }
    };

    const handleCloseAlert = () => {
        setAlertInfo({ ...alertInfo, show: false });
    };

    return (
        <div>
            <button className={"document-buttonn-red"} onClick={toggleModal}>უკან დაბრუნება</button>
            {isModalOpen && (
                <div className="return-case-manager-modal">
                    <div className="return-case-manager-modal-content">
                        <span className="return-case-manager-close" onClick={toggleModal}>&times;</span>
                        <form onSubmit={handleSubmit} className="return-case-manager-form">
                            <label htmlFor="comment">კომენტარი:</label>
                            <textarea id="comment" value={comment} onChange={handleCommentChange}></textarea>
                            <button disabled={!comment}  >დადასტურება</button>
                        </form>
                    </div>
                </div>
            )}
            <ConfirmationModal
                isOpen={isConfirmationOpen}
                onRequestClose={toggleConfirmation}
                onConfirm={confirmAndSubmit}
            />
            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={handleCloseAlert}
                />
            )}
        </div>
    );
};

export default ReturnCaseManagerButton;
